import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.833 3.333a.833.833 0 0 0-1.666 0v5.834H3.333a.833.833 0 0 0 0 1.666h5.834v5.834a.833.833 0 0 0 1.666 0v-5.834h5.834a.833.833 0 0 0 0-1.666h-5.834z"
    }, null, -1)
  ]))]))
}
export default { render: render }